import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"padding":"40px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicPagePlain = _resolveComponent("PublicPagePlain")!
  const _component_PublicPageStandard = _resolveComponent("PublicPageStandard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.notFound)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "プロジェクトが見つかりませんでした"))
      : _createCommentVNode("", true),
    (_ctx.publicPageData)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "projectTop",
          style: _normalizeStyle({'background':_ctx.viewLayoutRequest && _ctx.viewLayoutRequest.bodyBackGround})
        }, [
          (_ctx.publicPageData.layout === _ctx.PublicPageLayout.PLAIN)
            ? (_openBlock(), _createBlock(_component_PublicPagePlain, {
                key: 0,
                ref: "empty",
                kiwiIframeURL: _ctx.kiwiIframeURL,
                publicPageData: _ctx.publicPageData,
                publicPageTitle: _ctx.getPublicPageTitle(),
                projectUserName: _ctx.getPublicPageUserName(),
                viewLayoutRequest: _ctx.viewLayoutRequest
              }, null, 8, ["kiwiIframeURL", "publicPageData", "publicPageTitle", "projectUserName", "viewLayoutRequest"]))
            : (_openBlock(), _createBlock(_component_PublicPageStandard, {
                key: 1,
                ref: "standard",
                kiwiIframeURL: _ctx.kiwiIframeURL,
                publicPageData: _ctx.publicPageData,
                isPreview: _ctx.isPreview,
                publicPageTitle: _ctx.getPublicPageTitle(),
                projectUserName: _ctx.getPublicPageUserName(),
                viewLayoutRequest: _ctx.viewLayoutRequest
              }, null, 8, ["kiwiIframeURL", "publicPageData", "isPreview", "publicPageTitle", "projectUserName", "viewLayoutRequest"]))
        ], 4))
      : _createCommentVNode("", true)
  ], 64))
}